import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CAMPAIGNS_CATALOG, GET_CAMPAIGNS_CATALOG_SUCCESS, GET_CAMPAIGNS_CATALOG_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCampaignsCatalog({ payload }) {
  try {
    const { projectCode, campaignOn, urlParams } = payload;
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/campaigns/catalog?project_code=${projectCode}&campaignOn=${campaignOn}&page_size=1&page_index=10`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CAMPAIGNS_CATALOG_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CAMPAIGNS_CATALOG_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CAMPAIGNS_CATALOG_ERROR, payload: error });
  }
}

export function* watchGetCampaignCatalog() {
  yield takeEvery(GET_CAMPAIGNS_CATALOG, getCampaignsCatalog);
}

function* watchGetCampaignCatalogSaga() {
  yield all([fork(watchGetCampaignCatalog)]);
}

export default watchGetCampaignCatalogSaga;
